import { BehaviorSubject, Observable } from 'rxjs';
import { ProductionOverview } from '../Models/Production/ProductionOverview';
import { ProductionOverviewHelper } from '../Helpers/ProductionOverviewHelper';
import { authService } from '../App';

export class ProductionOverviewService {
  public FetchingReady: BehaviorSubject<boolean>;

  public productions!: Array<ProductionOverview>;

  constructor() {
    this.FetchingReady = new BehaviorSubject<boolean>(false);
    this.FetchItems();
  }

  private async FetchItems(forceUpdate: boolean = false) {
    if (!this.FetchingReady || forceUpdate) {
      this.productions = await ProductionOverviewHelper.GetOverview();
      this.FetchingReady.next(true);
    }
  }

  public GetFetchStatus(): Observable<boolean> {
    return this.FetchingReady.asObservable();
  }

  public async GetProductions(forceUpdate: boolean = false) {
    if (!this.FetchingReady || forceUpdate) {
      await this.FetchItems(true);
    }

    return this.productions;
  }

  public async UpdateProductionOverview(updatedItem: ProductionOverview) {
    var index = this.productions.findIndex((x) => x.id == updatedItem.id);
    this.productions[index] = updatedItem;
    ProductionOverviewHelper.UpdateOverview(
      updatedItem,
      authService.GetToken(),
    );
    return this.productions;
  }

  public async AddProductionOverview(newItem: ProductionOverview) {
    var createdItem = await ProductionOverviewHelper.AddOverview(
      newItem,
      authService.GetToken(),
    );
    if (this.productions == null) {
      this.productions = [createdItem];
    } else {
      this.productions.push(createdItem);
    }
    return this.productions;
  }

  public async RemoveProductionOverview(removeItem: ProductionOverview) {
    var index = this.productions.findIndex((x) => x.id == removeItem.id);
    this.productions.splice(index, 1);
    await ProductionOverviewHelper.DeleteOverview(
      removeItem,
      authService.GetToken(),
    );
    return this.productions;
  }

  public async ExportProductionOverviews() {
    let token = authService.GetToken();
    await ProductionOverviewHelper.ExportSetting(
      await this.GetProductions(),
      token,
    );
  }
}
